"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MicOff_exports = {};
__export(MicOff_exports, {
  default: () => MicOff_default
});
module.exports = __toCommonJS(MicOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.07812 5.17188C8.07812 4.50781 8.3125 3.94141 8.78125 3.47266C9.26302 2.99089 9.83594 2.75 10.5 2.75C11.1771 2.75 11.75 2.99089 12.2188 3.47266C12.7005 3.94141 12.9414 4.50781 12.9414 5.17188V9.82031C12.9414 9.97656 12.9219 10.1328 12.8828 10.2891C12.8568 10.4323 12.8177 10.5755 12.7656 10.7188L8.07812 6.03125V5.17188ZM8.07812 7.4375L12.1992 11.5586L13.4688 12.8281L14.2695 13.6289V13.6484L16.8477 16.2266C16.9518 16.3307 17.0039 16.4544 17.0039 16.5977C17.0039 16.7279 16.9518 16.8385 16.8477 16.9297C16.7565 17.0339 16.6393 17.0859 16.4961 17.0859C16.3659 17.0859 16.2487 17.0339 16.1445 16.9297L13.4688 14.2539C13.1042 14.4883 12.7135 14.6771 12.2969 14.8203C11.8802 14.9635 11.4505 15.0547 11.0078 15.0938V17.3398C11.0078 17.4701 10.9557 17.5872 10.8516 17.6914C10.7604 17.7826 10.6432 17.8281 10.5 17.8281C10.3698 17.8281 10.2526 17.7826 10.1484 17.6914C10.0573 17.5872 10.0117 17.4701 10.0117 17.3398V15.0938C9.3737 15.0286 8.77474 14.8724 8.21484 14.625C7.65495 14.3646 7.15365 14.0326 6.71094 13.6289C6.28125 13.2253 5.91667 12.75 5.61719 12.2031C5.33073 11.6693 5.13542 11.0964 5.03125 10.4844C5.00521 10.3281 4.98568 10.1784 4.97266 10.0352C4.95964 9.87891 4.95312 9.71615 4.95312 9.54688C4.95312 9.39062 5.00521 9.26042 5.10938 9.15625C5.22656 9.03906 5.36328 8.98047 5.51953 8.98047C5.67578 8.98047 5.80599 9.03906 5.91016 9.15625C6.02734 9.26042 6.08594 9.39062 6.08594 9.54688C6.08594 9.67708 6.09245 9.80729 6.10547 9.9375C6.11849 10.0547 6.13151 10.1719 6.14453 10.2891C6.23568 10.8099 6.41146 11.2982 6.67188 11.7539C6.93229 12.1966 7.2513 12.5872 7.62891 12.9258C8.01953 13.2513 8.46224 13.5052 8.95703 13.6875C9.4388 13.8828 9.95312 13.9805 10.5 13.9805C10.8906 13.9805 11.2617 13.9349 11.6133 13.8438C11.9779 13.7396 12.3164 13.6029 12.6289 13.4336L11.3203 12.1055C11.1901 12.1445 11.0534 12.1771 10.9102 12.2031C10.7799 12.2292 10.6432 12.2422 10.5 12.2422C9.83594 12.2422 9.26302 12.0078 8.78125 11.5391C8.3125 11.0573 8.07812 10.4844 8.07812 9.82031V8.86328L3.89844 4.68359C3.79427 4.59245 3.74219 4.47526 3.74219 4.33203C3.74219 4.1888 3.79427 4.07161 3.89844 3.98047C3.98958 3.8763 4.10677 3.82422 4.25 3.82422C4.39323 3.82422 4.51042 3.8763 4.60156 3.98047L8.07812 7.45703V7.4375ZM14.9531 12.8867C15.2135 12.5482 15.4284 12.1771 15.5977 11.7734C15.7799 11.3568 15.9102 10.9271 15.9883 10.4844C16.0143 10.3281 16.0339 10.1784 16.0469 10.0352C16.0599 9.87891 16.0664 9.71615 16.0664 9.54688C16.0664 9.39062 16.0078 9.26042 15.8906 9.15625C15.7865 9.03906 15.6497 8.98047 15.4805 8.98047C15.3242 8.98047 15.1875 9.03906 15.0703 9.15625C14.9661 9.26042 14.9141 9.39062 14.9141 9.54688C14.9141 9.67708 14.9076 9.80729 14.8945 9.9375C14.8945 10.0547 14.8815 10.1719 14.8555 10.2891C14.8034 10.6146 14.7122 10.9271 14.582 11.2266C14.4648 11.526 14.3151 11.8125 14.1328 12.0859L14.9531 12.8867Z",
      fill: "currentColor"
    }
  )
);
const SvgMicOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MicOff_default = SvgMicOff;
